import { enableCustomConfigBranding } from "../utils/configBranding";
import { enableRuntimeBranding } from "../utils/runtimeBranding";
import { myTheme } from './myTheme';
export const findTheme = (defaultTheme, brandingObj, runtimeBranding, clientappCustomBranding) => {
  const placeholderBrandingObj = {
    bodyText: "#333333",
    bodylink: "#34657f",
    fieldFocus: "#3e8529",
    primaryBtnText: "#FFFFFF",
    primaryBtnHover: "#3e8529",
    primaryBtnBackground: "#3e8529",
    secondaryBtnText: "#34657F",
    secondaryBtnHover: "#FFFFFF",
    footerBackground: "#FFFFFF",
    footerText: "#000"
  };
  const enableBranding = () => {
    const keys = Object.keys(brandingObj);
    const placeholderObjKeys = Object.keys(placeholderBrandingObj);
    placeholderObjKeys.filter(item => {
      return placeholderBrandingObj[item] = keys.includes(item) ? brandingObj[item] : placeholderBrandingObj[item];
    });
    let myCustomTheme = {
      link: placeholderBrandingObj.bodylink,
      body: {
        text: placeholderBrandingObj.bodyText
      },
      field: {
        focus: placeholderBrandingObj.fieldFocus
      },
      button: {
        primary: {
          text: placeholderBrandingObj.primaryBtnText,
          hover: placeholderBrandingObj.primaryBtnHover
        },
        secondary: {
          hover: placeholderBrandingObj.secondaryBtnHover
        },
        // text and icon color
        text: placeholderBrandingObj.secondaryBtnText,
        background: placeholderBrandingObj.primaryBtnBackground // sets bg and border
      },
      footer: {
        background: placeholderBrandingObj.footerBackground,
        text: placeholderBrandingObj.footerText
      }
    };
    return myCustomTheme;
  };
  if (defaultTheme == true) {
    return myTheme;
  } else {
    let myCustomTheme = {};
    if (brandingObj && runtimeBranding != {} || null) {
      brandingObj = enableRuntimeBranding(brandingObj, runtimeBranding);
      myCustomTheme = enableBranding();
    }
    if (clientappCustomBranding && brandingObj != null || {}) {
      myCustomTheme = enableCustomConfigBranding(brandingObj, clientappCustomBranding, myCustomTheme);
    }
    return myCustomTheme;
  }
};